/* global Coveo */

document.addEventListener("DOMContentLoaded", function () {

	var PUBLIC_API_KEY, options, search, searchbox, searchPageURI, site;

	site = document.querySelector("#site_data");
	try {
		site = JSON.parse(site.innerText);
	} catch (err) {
		/* eslint-disable no-console */
		console.warn(err);
		/* eslint-enable no-console */
		site = {};
	}

	if (site.coveo && site.coveo.public && site.coveo.public.api) {
		PUBLIC_API_KEY = site.coveo.public.api.key;
	} else {
		throw new Error("Public API Key for Coveo not found.");
	}
	searchbox = document.querySelector("#searchbox");
	search = document.querySelector("#search");

	Coveo.SearchEndpoint.configureCloudV2Endpoint(
		"",
		PUBLIC_API_KEY,
		"https://platform.cloud.coveo.com/rest/search",
		{
			"queryStringArguments": {
				"searchHub": "CommunitySearch"
			}
		}
	);

	if (search) {

		// bind custom event callbacks before initialization
		search.addEventListener("newResultDisplayed", hideShowMoreLink);

		// add an external component to the initialization options
		// to link the external search box to the search results
		Coveo.init(search, {
			"externalComponents": [searchbox]
		});

	} else {

		searchPageURI = "/search/";
		options = {
			"Omnibox": {
				"placeholder": "Search"
			}
		};

		if (location.pathname.match(/^\/vulnerability-detection-pipeline/)) {
			searchPageURI = site.community.base.url + "/search/";
			options.Omnibox.placeholder = "Search Discussions, Blog Posts, Training, Docs and Support";
		}

		if (location.pathname.match(/^\/documentation/)) {

			// searching from a Docs page
			searchPageURI = site.community.base.url + "/search/#t=Docs";
			options.Omnibox.placeholder = "Search documentation";

		}

		if (location.pathname.match(/^\/training/)) {

			// searching from a Training page
			searchPageURI = site.community.base.url + "/search/#t=Training";
			options.Omnibox.placeholder = "Search training";

		}

		// call initSearchBox to setup the standalone search box
		Coveo.initSearchbox(searchbox, searchPageURI, options);

	}


	// helper function to hide "Show more" links when there are no more results to show
	function hideShowMoreLink (event) {

		var result = event.detail.result;
		var item = event.detail.item;
		var totalNumberOfChildResults = result.raw.jivereplycount || result.raw.wpcommentcount || 0;
		var numberOfChildResultsShown = result.childResults.length;
		var numberOfChildResultsRemaining = totalNumberOfChildResults - numberOfChildResultsShown;

		if (numberOfChildResultsRemaining < 1) {

			// hide Show more link
			var coveoFoldingFooter = item.querySelector(".coveo-folding-footer");
			if (coveoFoldingFooter) {
				coveoFoldingFooter.classList.add("hidden");
			}

		}

	}

});
